export enum SyncKey {
  WOLT = 'wolt',
  UBER_EATS = 'uberEats',
  JET = 'jet',
  DELIVEROO = 'deliveroo',
}
